(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trynvia-builder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tv-builder-form').forEach(form=>{
const update=()=>{let sum=0,count=0;form.querySelectorAll('.tv-builder-item').forEach(row=>{const check=row.querySelector('.tv-builder-check');row.querySelector('.tv-builder-id').disabled=!check.checked;row.querySelector('.tv-builder-qty').disabled=!check.checked;if(check.checked){sum+=Number(check.dataset.price);count++}});form.querySelector('.tv-builder-total').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(sum/100);form.querySelector('.tv-builder-submit').disabled=count===0;};
form.addEventListener('change',update);update();form.hidden=false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv2-need"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var tile = e.target.closest('.tv2-need__tile[data-tv2-target]');
  if (!tile) return;
  var handle = tile.getAttribute('data-tv2-target');
  var card = handle ? document.getElementById('tv2-set-' + handle) : null;
  if (!card) return;
  e.preventDefault();
  document.querySelectorAll('.tv2-set--hit').forEach(function(c){ c.classList.remove('tv2-set--hit'); });
  card.classList.add('tv2-set--hit');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center', inline: 'center' });
  setTimeout(function(){ card.classList.remove('tv2-set--hit'); }, 2600);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv2-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var btn = e.target.closest('.tv2-video__play');
  if (!btn) return;
  var fig = btn.closest('.tv2-video');
  var vid = fig && fig.querySelector('video');
  if (!vid) return;
  if (vid.paused) {
    document.querySelectorAll('.tv2-video video').forEach(function(v){ if (v !== vid && !v.paused) { v.pause(); v.closest('.tv2-video').classList.remove('is-playing'); } });
    vid.muted = false;
    vid.play().then(function(){ fig.classList.add('is-playing'); btn.setAttribute('aria-label','Pause video'); }).catch(function(){ vid.muted = true; vid.play(); fig.classList.add('is-playing'); });
  } else {
    vid.pause(); fig.classList.remove('is-playing'); btn.setAttribute('aria-label','Play video');
  }
});

  } catch(e) { console.error(e); }
})();
})();
